import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { MeetingActionItemSchema } from "@app/lib/api/meetings/meeting_action_item_schema";
import { z } from "zod";

export const MEETING_TASKS_SERVER_NAME = "meeting_tasks" as const;
export const PROPOSE_TASKS_TOOL_NAME = "propose_tasks";

export const MEETING_TASKS_TOOLS_METADATA = [
  {
    name: PROPOSE_TASKS_TOOL_NAME,
    description:
      "Propose the concrete unfinished actions extracted from this meeting's notes as tasks. Call this exactly once per run, including when none are found by passing an empty array. Every item is checked against the fetched notes: unverifiable excerpts are discarded and reported, and items already proposed by an earlier attempt for this meeting are not duplicated.",
    schema: {
      action_items: z
        .array(MeetingActionItemSchema)
        .describe(
          "One atomic proposal for every concrete unfinished action recorded in the notes, including each qualifying item under Remaining work, Next steps, TODO, Action items, Follow-ups, or a similar list, even without an explicit promise or accepted request. Exclude completed work, discussion, background, vague ideas, already-resolved requests, and duplicates."
        ),
    },
    // An internal write, deliberately: the proposals land as pending
    // suggestions in Home and on the personal Tasks board In review, which
    // is itself the review step, and nothing leaves MemoAir. Asking here
    // would put a modal in front of a routine run nobody is watching, which
    // is the one way this routine cannot work.
    stake: "never_ask",
    // The whole run exists to reach this tool, so it is never worth a tool
    // search round trip.
    eager: true,
    displayLabels: {
      running: "Proposing tasks from the meeting",
      done: "Proposed tasks from the meeting",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const MEETING_TASKS_SERVER = {
  serverInfo: {
    name: MEETING_TASKS_SERVER_NAME,
    version: "1.0.0",
    description:
      "Turn action items extracted from a finished meeting's notes into validated, deduplicated task proposals in the owner's Home.",
    authorization: null,
    icon: "ActionCheckCircleIcon",
    documentationUrl: null,
  },
  tools: MEETING_TASKS_TOOLS_METADATA,
} as const satisfies ServerMetadata;
